module.exports = __webpack_public_path__ + "img/tablet-VTA-VALORACION-DOMICILIO01.6bc521b4.png";